<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import {
  getToolkits as fetchData,
  deleteToolkit as deleteRow,
} from "@/api/toolkits";

const columnsOptions = {
  sortable: "custom",
  controls: {
    width: 270,
  },
  id: "id",
  edit: true,
  delete_row: {
    buttonName: "Удалить",
    confirm: true,
  },
};

const columns = [
  {
    prop: "id",
    label: "ID",
  },
  {
    prop: "priority",
    label: "Приоритет",
  },
  {
    prop: "name",
    label: "Название",
  },
  {
    prop: "url",
    label: "Ссылка на документ",
    type: "link",
    sortable: false,
  },
  {
    prop: "image",
    label: "Изображение",
    type: "preview",
    sortable: false,
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
        deleteRow,
      },
    };
  },
  methods: {
    async fetchData(params) {
      const { limit = 100, offset = 0, sort } = params;
      const response = await fetchData({ limit, offset, sort });
      return response.data;
    },
  },
};
</script>
